export { default as Loading } from './Loading';
// export { default as PowerBi } from './PowerBi';
export { default as ContentDetail } from './ContentDetail';
export { default as ModalDownLoadReport } from './ModalDownLoadReport';